<template>
  <div>
    <div class="p-top-wrapper">
      <div class="p-top">
        <div class="p-left" @click="gohome">
          <img
            :src="require('@/assets/img/common/back_home@2x.png')"
            alt=""
            class="p-image-home"
          />
          <div class="p-backtips">返回首页</div>
        </div>
        <div class="p-arrow-tips">></div>
        <div class="p-map-tips">{{ detail.title }}</div>
      </div>
    </div>
    <div class="new-era-theory-detail">
      <NewDetail v-if="!loading" :detail="detail" />
    </div>
  </div>
</template>


<script>
import NewDetail from "@/components/common/NewDetail";
export default {
  components: { NewDetail },
  data() {
    return {
      loading: true,
      detail: {},
    };
  },
  mounted() {
    this.getDetail(this.$route.params.id);
  },
  methods: {
    gohome() {
      this.$EventBus.$emit("gotoPanel", { key: "home" });
      this.$router.push("/");
    },
    getDetail(id) {
      this.$api.xsdapi.newsInfo({ id: id }).then((res) => {
        this.detail = res;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.p-top-wrapper {
  width: 1200px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  top: 20px;
}
.p-top {
  marign: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 16px;
  margin-bottom: 57px;
  .p-left {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 16px;
    .p-image-home {
      width: 26px;
      height: 26px;
      margin-right: 6px;
    }
  }
  .p-arrow-tips {
    margin: 0 5px;
  }
  .p-map-tips {
    cursor: pointer;
    color: #cd3232;
  }
}
.new-era-theory-detail {
  width: 1200px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background: #ffffff;
  margin-bottom: 24px;
  padding-top: 10px;
}
</style>